import { Node, mergeAttributes } from '@tiptap/core';

/** Editor-only boundary; message serialization strips these nodes. */
export const EmailSignatureBoundary = Node.create({
  name: 'emailSignatureBoundary',
  group: 'block',
  atom: true,
  selectable: false,
  addAttributes() {
    return {
      edge: {
        default: 'start',
        rendered: false,
        parseHTML: (element: HTMLElement) => {
          const edge = element.getAttribute('data-experviser-signature-boundary');
          return edge === 'start' || edge === 'end' ? edge : null;
        },
      },
      signatureId: {
        default: null,
        rendered: false,
        parseHTML: (element: HTMLElement) => {
          const value = element.getAttribute('data-signature-id');
          return value && /^\d+$/.test(value) ? value : null;
        },
      },
    };
  },
  parseHTML() {
    return [{
      tag: 'div[data-experviser-signature-boundary]',
      getAttrs: (element) => {
        const edge = (element as HTMLElement).getAttribute('data-experviser-signature-boundary');
        return edge === 'start' || edge === 'end' ? {} : false;
      },
    }];
  },
  renderHTML({ node, HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, {
      'data-experviser-signature-boundary': node.attrs.edge,
      ...(node.attrs.signatureId ? { 'data-signature-id': node.attrs.signatureId } : {}),
      style: 'display: none',
      contenteditable: 'false',
    })];
  },
});
